/**
 * Created by contrapro on 2018/5/24
 */


import React from 'react';
import { Component } from "react";
import { connect } from 'react-redux';
import './SharePageSoup.css';
import qrcode from '../../../assets/imgs/qrcode.jpg';
import k11 from '../../../assets/imgs/k11logo.png';
import scanner from '../../../assets/imgs/scanner.png';
import { STATIC_HOST_PROD } from "../../../util/serverUtil";
import { getParameterByName } from "../../../util/queryUtil";


class SharePageSoup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imgSrc: '',
            found: false,
            showTip: false,
        };
        //
        // this.onWishTypeClick = this.onWishTypeClick.bind(this);


    }

    componentDidMount() {

        let img = '';

        const share = getParameterByName('share');
        const name = getParameterByName('filename');

        if (share === 'wish' && name) {

            img = STATIC_HOST_PROD + '/works/' + name + '.jpg';

        } else {
            if(this.props.currentWorkName === '') {
                img = STATIC_HOST_PROD + '/works/' + 'mark' + '.jpg';//'0110000009986'
            } else {
                img = STATIC_HOST_PROD + '/works/' + this.props.currentWorkName + '.jpg';//'0110000009986'
            }

        }



        var tester = new Image();
        tester.onload = () => {
            console.log('img found', img);
            this.setState({
                    ...this.state,
                    imgSrc: img,
                    found: true,
                    showTip: false
                }
            )
        };
        tester.onerror = () => {
            console.log('img not found', img);
            this.setState({
                    ...this.state,
                    imgSrc: scanner,
                    found: false,
                    showTip: true
                }
            )
        }
        tester.src = img;
    }

    render() {
        return (
            <div className="SharePageSoup">
                <div className="SharePageSoup-mask">
                    <img className={this.state.found ? 'SharePageSoup-mask-img':'SharePageSoup-mask-notfound-img'} alt="" src={this.state.imgSrc}/>
                    {!this.state.found && this.state.showTip &&
                    <p>您的作品还没有入库哦～<br/>请到扫描仪处扫描作品</p>}
                </div>
                <div className="SharePageSoup-footer">
                    <div className="SharePageSoup-footer-left">
                        <span className="SharePageSoup-footer-helper"></span>
                        <img alt="" src={qrcode}/>

                    </div>

                    <div className="SharePageSoup-footer-middle">
                        <p>K11沈阳公园马戏团</p>
                        <p>关注公众号获取惊喜好礼</p>
                    </div>
                    <div className="SharePageSoup-footer-right">
                        <span className="SharePageSoup-footer-helper"></span>
                        <img alt="" src={k11}/>
                    </div>
                </div>
            </div>
        );
    }
}

// export default SharePageSoup;
export default connect(state => ({
        viewState: state.viewStateReducer.viewState,
        currentWorkName: state.workReducer.currentWorkName
    }),
    dispatch => ({
        // updateViewState: (sceneData) => {
        //     dispatch(updateViewState(sceneData))
        // },
        // addWish: (type) => {
        //     dispatch(addWish(type))
        // },
        // onShareOK: () => {
        //     // dispatch(authFail())
        //     dispatch(onShareOK())
        // },
    }))(SharePageSoup)


// WEBPACK FOOTER //
// ./src/react/views/sharePage/SharePageSoup.js